import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    show: false,
    message: '',
    color: '',
  }),
  actions: {
    showToast(toast) {
      this.show = true;
      this.message = toast.message;
      this.color = toast.color;

      setTimeout(() => {
        this.show = false;
        this.message = '';
        this.color = '';
      }, 3000);
    },
  },
});